/**
 * Default entity ATIs for Assets/CMDB (1P).
 */
import type { AssetsEntityATI } from '@atlassian/search-client/common/types';

export type ReadonlyAssetsEntityATI = readonly AssetsEntityATI[];

export const DEFAULT_ASSETS_ENTITY_ATI: ReadonlyAssetsEntityATI = [
	'ati:cloud:cmdb:object',
	'ati:cloud:cmdb:schema',
	'ati:cloud:cmdb:type',
];
